import React from 'react';
import mainscreen from '../Image/mainscreen.png';
import { useNavigate } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleCheck,faToolbox,faScrewdriverWrench } from '@fortawesome/free-solid-svg-icons';
import '../Css/HomeScreen.css';


function HomeScreen() {
  return (
    <div className="mainScreen-Wrapper">
          <div className="mainScreen-Header">
            <h1>香港專業<strong>家居維修</strong>配對平台 - 維修王</h1>
            <h2>一App 在手，即時配對水電、冷氣及各類<strong>家居維修</strong>師傅</h2>
          </div>
          <div className="mainScreen-Content">
            <ul>
                <li><FontAwesomeIcon icon={faCircleCheck} />&nbsp;提供一站式專業<strong>家居維修</strong>服務。無論是水電維修、冷氣清洗，還是油漆翻新，我們的認證師傅都能為你提供最快速的服務</li>
                <li><FontAwesomeIcon icon={faCircleCheck}/>&nbsp;打造方便,易用,保障客戶私隱的專業維修平台。只需透過我們的 Android 或 iPhone App,即可輕鬆預約專業師傅上門。</li>
                <li><FontAwesomeIcon icon={faCircleCheck} />&nbsp;由經驗豐富的<strong>家居維修</strong>專家領導,為<strong>家居維修</strong>業界釐定專業標準。</li>
                <li><FontAwesomeIcon icon={faCircleCheck} />&nbsp;為有志從事家居維修行業的朋友,提供專業培訓課程。</li>
            </ul>
          </div>
          
    </div>
    
  )
}

export default HomeScreen

